import React from 'react';

import { Button } from '@missionlabs/smartagent-app-components';

import useHasFeature, { useGetFeatureConfig, AppFeatures, AppSubFeatures } from 'hooks/useHasFeature';
import useMonitoring from 'hooks/redux/useMonitoring';

import styles from './controls.module.scss';

export type Props = {
    isBarging: boolean;
    onMonitor: () => void;
    onBarge: () => void;
    onLeave: () => void;
};

const Controls: React.FC<Props> = ({ isBarging, onMonitor, onBarge, onLeave }) => {
    const hasFeature = useHasFeature();
    const getFeatureConfig = useGetFeatureConfig();
    const { isEnhancedMonitoringEnabled } = useMonitoring();

    const { allowBarge = false } = getFeatureConfig(AppFeatures.LIVE_MONITORING);
    const hasBargeSubFeature = hasFeature(AppFeatures.LIVE_MONITORING, AppSubFeatures.ALLOW_BARGE);
    const canBarge = allowBarge && hasBargeSubFeature && isEnhancedMonitoringEnabled;

    return (
        <div className={styles.container}>
            <Button styling="red" type="button" onClick={onLeave}>
                End monitoring
            </Button>
            {isBarging ? (
                <Button onClick={onMonitor} styling="white">
                    Return to monitoring
                </Button>
            ) : (
                canBarge && (
                    <Button onClick={onBarge} styling="white">
                        Barge
                    </Button>
                )
            )}
        </div>
    );
};

export default Controls;
